import type { LinkedSwapPlan } from './useScheduleConflicts'

export type LinkedSwapTarget = {
  dayOfWeek: number
  period: number
}

export type LinkedSwapSource = {
  sourceDay: number | null
  sourcePeriod: number | null
  /** 被拖课时来自暂存区：回源组一并回到暂存区，而不是源格 */
  fromStaging: boolean
}

/**
 * 把一次对调方案落到草稿上（原地修改，与旧版排课详情的落定语义一致）。
 *
 * - moverGroup：移动到目标位
 * - returningGroup：目标格占位课及其联动闭包回到被拖课时的源位
 * - displacedGroup：回源成员在源格上的占位课被顶到目标位
 *
 * 预检（冲突/硬拒绝）由 useScheduleConflicts 负责，本函数只做落定。
 */
export function applyLinkedSwapPlan(
  plan: LinkedSwapPlan,
  target: LinkedSwapTarget,
  source: LinkedSwapSource
): void {
  for (const member of plan.returningGroup) {
    if (source.fromStaging) {
      member.placed = false
      member.dayOfWeek = null
      member.period = null
      member.roomId = null
      member.roomName = null
      continue
    }
    member.placed = true
    member.dayOfWeek = source.sourceDay
    member.period = source.sourcePeriod
  }

  for (const member of plan.displacedGroup) {
    member.placed = true
    member.dayOfWeek = target.dayOfWeek
    member.period = target.period
  }

  for (const member of plan.moverGroup) {
    member.placed = true
    member.dayOfWeek = target.dayOfWeek
    member.period = target.period
  }
}
